import React, { useState } from 'react';
import { Container, Card, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AuthService from '../../services/AuthService';
import CustomSnackbar from '../../components/CustomSnackbar';

const EMPTY = { currentPassword: '', newPassword: '', confirmPassword: '' };

// Al menos 1 minúscula, 1 mayúscula, 1 número y 1 carácter especial.
const STRONG_PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/;

function ChangePassword() {
  const navigate = useNavigate();
  const [form, setForm] = useState(EMPTY);
  const [snackbar, setSnackbar] = useState({ open: false, type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const notify = (type, message) => setSnackbar({ open: true, type, message });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (form.newPassword.length < 12) {
      notify('error', 'La nueva contraseña debe tener al menos 12 caracteres');
      return;
    }
    if (!STRONG_PASSWORD.test(form.newPassword)) {
      notify(
        'error',
        'La contraseña debe incluir mayúscula, minúscula, número y carácter especial',
      );
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      notify('error', 'Las contraseñas no coinciden');
      return;
    }

    try {
      setLoading(true);
      const result = await AuthService.changePassword(
        form.currentPassword,
        form.newPassword,
      );
      if (result.success) {
        notify('success', 'Contraseña actualizada correctamente');
        setForm(EMPTY);
        setTimeout(() => navigate('/'), 1500);
      } else {
        notify('error', result.message);
      }
    } catch (error) {
      console.error('Error al cambiar la contraseña:', error);
      notify('error', 'Ocurrió un error al cambiar la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-4" style={{ maxWidth: '480px' }}>
      <Card>
        <Card.Header className="bg-primary text-white text-center">
          <h5 className="m-0">Cambiar contraseña</h5>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Contraseña actual</Form.Label>
              <Form.Control
                type="password"
                name="currentPassword"
                value={form.currentPassword}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Nueva contraseña</Form.Label>
              <Form.Control
                type="password"
                name="newPassword"
                value={form.newPassword}
                onChange={handleChange}
                disabled={loading}
                minLength={12}
                required
              />
              <Form.Text muted>
                Mínimo 12 caracteres, con mayúscula, minúscula, número y carácter
                especial.
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Repetir nueva contraseña</Form.Label>
              <Form.Control
                type="password"
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-2">
              <Button
                variant="secondary"
                type="button"
                onClick={() => navigate('/')}
                disabled={loading}
              >
                Cancelar
              </Button>
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? 'Guardando...' : 'Cambiar contraseña'}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>

      <CustomSnackbar
        open={snackbar.open}
        type={snackbar.type}
        message={snackbar.message}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
      />
    </Container>
  );
}

export default ChangePassword;
